import { IKnmForm } from 'KnmPackage/MainModule/interfaces/IKnmForm';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';

import { IPmErknmSubjectFieldPaths } from '../hooks/usePmErknmSubjectFields';

interface IClearPmSubjectFieldsParams {
  formRef: IKnmFormRef | undefined;
  subjectFieldNames: IPmErknmSubjectFieldPaths;
  withSubjectType?: boolean;
}

/**
 * Сброс полей контролируемого лица в форме ПМ.
 *
 * Работает напрямую с формой и не зависит от того, смонтирован ли PmSubjectItem: гармошка КЛ
 * не рендерит содержимое, пока её ни разу не раскрыли (KnmCollapse), поэтому опираться на ref
 * дочернего компонента при удалении КЛ нельзя.
 */
export const clearPmSubjectFields = ({
  formRef,
  subjectFieldNames,
  withSubjectType = false,
}: IClearPmSubjectFieldsParams): void => {
  if (!formRef) {
    return;
  }

  const fieldNames: string[] = [
    subjectFieldNames.inn,
    subjectFieldNames.snils,
    subjectFieldNames.organizationName,
    subjectFieldNames.isFiz,
    subjectFieldNames.ogrn,
    subjectFieldNames.locationAddress,
    subjectFieldNames.workAddress,
    subjectFieldNames.factualAddress,
    subjectFieldNames.country,
    subjectFieldNames.okveds,
    subjectFieldNames.kpp,
    subjectFieldNames.rafpNza,
    subjectFieldNames.document,
    subjectFieldNames.nkoForeignAgentsRegistryNumber,
    subjectFieldNames.nkoForeignAgentsRegistryInclusionDate,
    subjectFieldNames.nkoForeignAgentsRegistryExclusionDate,
    subjectFieldNames.isNkoFieldName,
    subjectFieldNames.ervkId,
    subjectFieldNames.firstOrganizationName,
    subjectFieldNames.dateCreate,
    subjectFieldNames.mspCode,
    subjectFieldNames.mspRegistryDate,
    subjectFieldNames.checkSubjectResult,
    subjectFieldNames.locationnotInFIAS,
    subjectFieldNames.locationmanualAddress,
    subjectFieldNames.locationregion,
    subjectFieldNames.locationfiasRegion,
    subjectFieldNames.locationRegionName,
    subjectFieldNames.smevRequestStatus,
    subjectFieldNames.organizationAutocomplete,
    ...(withSubjectType ? [subjectFieldNames.subjectTypePm] : []),
  ];

  fieldNames.forEach(fieldName => formRef.current?.change(fieldName as keyof IKnmForm, undefined));
};
